import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';

class ScrollItem__BlockLogos extends ScrollItem__BlockDefault {
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);
    }
}

Scroll._registerClass('BlockLogos', ScrollItem__BlockLogos);

export default ScrollItem__BlockLogos;
